export default __webpack_public_path__ + "static/media/digital-blob.98ef3672.svg";